import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from 'src/app/store/server-communication/running-actions/types/longRunningAction.decorator';
import { IBrickInstanceTargetingAction } from 'src/app/store/utility/IBrickInstanceTargetingAction';
import { BrickInstancesWithTabSettingsRemoteDto } from 'src/generated/signalR/brick-instances-with-tab-settings-remote-dto';

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class BrickTabSettingsUpdatedByServer {
   public static readonly type = '[BrickTabState] Brick Tab Settings Updated By Server';

   constructor(
      public data: {
         [key: string]: BrickInstancesWithTabSettingsRemoteDto;
      }
   ) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class PersistAllTabConfigurations {
   public static readonly type = '[BrickTabState] Persist All Tab Configurations';

   constructor(public brickInstanceIds: string[]) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class PersistTabConfiguration implements IBrickInstanceTargetingAction {
   public static readonly type = '[BrickTabState] Persist Tab Configuration';

   constructor(public brickInstanceId: string, public gridId = 'default') {}
}

export class SetSelectedTabIndex implements IBrickInstanceTargetingAction {
   public static readonly type = '[BrickGridsState] SetTabIndex';

   constructor(public brickInstanceId: string, public selectedTabIndex: number, public gridId = 'default') {}
}

export class SetAndPersistSelectedTabIndex implements IBrickInstanceTargetingAction {
   public static readonly type = '[BrickGridsState] Set And Persist Selected Tab Index';

   constructor(public brickInstanceId: string, public selectedTabIndex: number, public gridId = 'default') {}
}
